<template>
    <div class="bg-primary-950 py-10 sm:py-18">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
                <div v-for="stat in stats" :key="stat.id" class="mx-auto flex max-w-xs flex-col gap-y-4">
                    <dt class="text-base/7 text-primary-200">{{ stat.name }}</dt>
                    <dd class="font-display order-first text-3xl text-gold-400 sm:text-5xl">{{
                        stat.value }}</dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

const stats = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/stats');
    stats.value = response.data.data;
});
</script>
